// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 37.5rem) {\n.upload--bottom[data-v-dc4e9b46] {\n    margin: 0 !important;\n    display: flex;\n    flex-direction: column;\n}\n.upload--bottom label[data-v-dc4e9b46] {\n    margin: 0 0 1rem !important;\n    width: 100%;\n}\n.upload--bottom button[data-v-dc4e9b46] {\n    margin-bottom: 1rem;\n}\n}", ""]);
// Exports
module.exports = exports;
